// @ts-check
import { Link } from 'react-router-dom';
import { label, modelLetter, STAGE_ORDER } from '../../utils/wholesale';
import { StageBadge } from './shared';

/**
 * The pipeline as eleven columns. Cards link to the partner; the stage is changed on the partner page,
 * where the evidence it needs is visible.
 * @param {{partners: any[]}} props
 */
const PartnersBoard = ({ partners }) => (
  <div className="flex gap-3 overflow-x-auto pb-3">
    {STAGE_ORDER.map((stage) => {
      const inStage = partners.filter((p) => p.stage === stage);
      return (
        <div key={stage} className="w-60 flex-shrink-0 bg-muted/40 rounded-lg p-2">
          <div className="flex items-center justify-between px-1 pb-2">
            <StageBadge stage={stage} />
            <span className="text-xs text-muted-foreground">{inStage.length}</span>
          </div>
          <div className="space-y-2">
            {inStage.map((p) => (
              <Link
                key={p.id}
                to={`/wholesale/${p.id}`}
                className="block bg-card border border-border rounded-lg p-3 hover:border-foreground/40 transition"
              >
                <div className="flex items-start justify-between gap-2">
                  <span className="text-sm font-medium leading-snug">{p.name}</span>
                  {p.open_reminders > 0 && (
                    <span className="flex-shrink-0 text-xs px-1.5 rounded bg-amber-100 text-amber-800 dark:bg-amber-950/60 dark:text-amber-300" title="Follow-ups due">
                      {p.open_reminders}
                    </span>
                  )}
                </div>
                <p className="text-xs text-muted-foreground mt-0.5">
                  {[p.city, label(p.kind)].filter(Boolean).join(' · ')}
                </p>
                <p className="text-xs text-muted-foreground mt-1">
                  {p.days_in_stage}d in stage{p.lead_model ? ` · lead ${modelLetter(p.lead_model)}` : ''}
                </p>
                {p.next_action && <p className="text-xs mt-1.5 line-clamp-2">{p.next_action}</p>}
              </Link>
            ))}
          </div>
        </div>
      );
    })}
  </div>
);

export default PartnersBoard;
